module.exports = __webpack_public_path__ + "img/societario.c15df198.png";